// extracted by mini-css-extract-plugin
export default {"rowContainer":"triage_row_rowContainer__VzTLd","item":"triage_row_item__4cjeP"};